import {
  getBreadCrumbList,
  setTagNavListInLocalstorage,
  getMenuByRouter,
  getTagNavListFromLocalstorage,
  getHomeRoute,
  getNextRoute,
  routeHasExist,
  routeEqual,
  getRouteTitleHandled,
  localSave,
  localRead
} from '@/libs/util'
import router from '@/router'
import routes from '@/router/routers'
import { dynamicRouterAdd } from '@/libs/router-utils'

const closePage = (state, route) => {
  const nextRoute = getNextRoute(state.tagNavList, route)
  state.tagNavList = state.tagNavList.filter(item => {
    return !routeEqual(item, route)
  })
  router.push(nextRoute)
}

// 启动时立即从 sessionStorage 恢复菜单（修复"新浏览器/刷新后侧边栏空白，再刷新才出来"）
// vuex 是新建的（页面刷新、浏览器恢复 session、新 tab），state.menuList 默认是 []，
// getter 兜底用的 routes（顶层 ES Module 求值结果）也可能是登录前固化的空 appRouter。
// 在 store 初始化阶段同步取一次 sessionStorage.dynamicRouter 把 menuList 充上数据，能保证 main.vue
// 第一次渲染就拿到非空菜单，无需用户再 F5。
const restoreMenuListOnBoot = () => {
  try {
    const list = dynamicRouterAdd()
    return Array.isArray(list) ? list : []
  } catch (e) {
    console.warn('[app store] restoreMenuListOnBoot 失败：', e)
    return []
  }
}

export default {
  state: {
    breadCrumbList: [],
    tagNavList: [],
    menuList: restoreMenuListOnBoot(),
    homeRoute: {},
    local: localRead('local'),
    errorList: [],
    hasReadErrorPage: false
  },
  getters: {
    menuList: (state, getters, rootState) => {
      if (state.menuList.length > 0) {
        return getMenuByRouter(state.menuList, rootState.user.userInfo.access)
      } else {
        return getMenuByRouter(routes, rootState.user.userInfo.access)
      }
    },
    errorCount: state => state.errorList.length
  },
  mutations: {
    setBreadCrumb (state, route) {
      state.breadCrumbList = getBreadCrumbList(route, state.homeRoute)
    },
    updateMenuList (state, r) {
      router.addRoutes(r)
      state.menuList = r
    },
    setHomeRoute (state, routes) {
      state.homeRoute = getHomeRoute(routes, 'home')
    },
    setTagNavList (state, list) {
      let tagList = []
      if (list) {
        tagList = [...list]
      } else tagList = getTagNavListFromLocalstorage() || []
      if (tagList[0] && tagList[0].name !== 'home') tagList.shift()
      let homeTagIndex = tagList.findIndex(item => item.name === 'home')
      if (homeTagIndex > 0) {
        let homeTag = tagList.splice(homeTagIndex, 1)[0]
        tagList.unshift(homeTag)
      }
      state.tagNavList = tagList
      setTagNavListInLocalstorage([...tagList])
    },
    closeTag (state, route) {
      let tag = state.tagNavList.filter(item => routeEqual(item, route))
      route = tag[0] ? tag[0] : null
      if (!route) return
      closePage(state, route)
    },
    addTag (state, { route, type = 'unshift' }) {
      let router = getRouteTitleHandled(route)
      if (!routeHasExist(state.tagNavList, router)) {
        if (type === 'push') state.tagNavList.push(router)
        else {
          if (router.name === 'home') state.tagNavList.unshift(router)
          else state.tagNavList.splice(1, 0, router)
        }
        setTagNavListInLocalstorage([...state.tagNavList])
      }
    },
    setLocal (state, lang) {
      localSave('local', lang)
      state.local = lang
    },
    addError (state, error) {
      state.errorList.push(error)
    },
    addMenuName (state, name) {
      state.menuName = name
    }
  }
}
